import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadDispatch, loadDispatchError,ignoreDisconnect } from '../actions/index';
import { findByid } from "../../../utils";
import { extractCenterId } from "../../../utils/center";
import { ChangeNumberOfBagsModal } from "./modal/ChangeNumberOfBagsModal";
import { Docks } from "./Docks";
import { Deliveries } from "./Deliveries";
import { SourceSwitch } from "./SourceSwitch";
import { TransitAreaModal } from "./modal/TransitAreaModal";
import { ChangeTrolleyLocationModal } from "./modal/ChangeTrolleyLocationModal";
import { ConfirmModal } from "../../support/components/ConfirmModal";
import ReviewLateOrderModal from './modal/ReviewLateOrderModal';
import ReturnBagsDepositModal from './modal/ReturnBagsDepositModal';
import StuartCallModalLinked from './modal/StuartCallModalLinked';
import UberCallModalLinked from './modal/UberCallModalLinked';
import UberDirectBatchModalLinked from './modal/UberDirectBatchModalLinked';
import UberCancelResolutionModalLinked from './modal/UberCancelResolutionModalLinked';
import RedeliverOrRestockModal from './modal/RedeliverOrRestockModal';
import '../css/Dispatch.css';
import {RouteComparisonModal} from "./modal/RouteComparisonModal";
import {withRouter} from "react-router-dom";
import {CommonModals} from "../../../common-comps/CommonModals";
import { api } from "../../../api";
import { getDryRun } from "../dryRun";
import { DockEstimatesContext } from "../DockEstimatesContext";
import { DockHighlightContext } from "../DockHighlightContext";

// Totaux estimés recalculés côté client à partir des docks estimés (permet d'inclure/exclure les
// tournées à 1 commande — les conteneurs brouillon du dispatcheur — pour une compa pomme-à-pomme).
function estTotals(entries) {
  const cost = entries.reduce((s, d) => s + (d.cost_eur || 0), 0);
  const delay = entries.reduce((s, d) => s + (d.delay_min || 0), 0);
  const wait = entries.reduce((s, d) => s + (d.wait_min || 0), 0);
  return {
    docks: entries.length,
    bags: entries.reduce((s, d) => s + (d.bags || 0), 0),
    cost_eur: Math.round(cost * 100) / 100,
    delay_min: Math.round(delay * 10) / 10,
    wait_min: Math.round(wait * 10) / 10,
  };
}

let loadingInterval = null;

class InternalDispatch extends React.Component {

  state = {
    showTools: false,           // pile d'outils dry-run (déployée via le bouton latéral)
    showDeliveries: true,       // colonne « Commandes à dispatcher » (masquable pour gagner de la place)
    highlightParis: false,      // entourer les docks 100% Paris intramuros (tournées scooter)
    includeEstSingles: false,   // inclure les tournées à 1 commande dans les totaux estimés
    showEstimates: false,       // coûts estimés masqués par défaut
    dockEstimates: {},
    estimatesTotals: null,
    estimatesTotalsParis: null,
    estimatesDiagnostic: null,
    estimatesLoading: false,
  };

  toggleTools = () => {
    this.setState({ showTools: !this.state.showTools });
  };

  toggleDeliveries = () => {
    this.setState({ showDeliveries: !this.state.showDeliveries });
  };

  toggleHighlightParis = () => {
    this.setState({ highlightParis: !this.state.highlightParis });
  };

  // Métriques ISO estimées par notre lib, par dock réel (pour comparer l'efficacité de la lib au
  // dispatch réel — utile aussi en prod). À la demande (pas à chaque refresh auto).
  fetchEstimates = () => {
    const { centerId } = this.props;
    if (!centerId) { return; }
    this.setState({ estimatesLoading: true });
    api.dockEstimates(centerId, getDryRun())
      .then((r) => this.setState({
        dockEstimates: r.docks || {}, estimatesTotals: r.totals || null,
        estimatesTotalsParis: r.totals_paris || null, estimatesDiagnostic: r.diagnostic || null,
        estimatesLoading: false,
      }))
      .catch(() => this.setState({ estimatesLoading: false }));
  };

  toggleEstimates = () => {
    const on = !this.state.showEstimates;
    this.setState({ showEstimates: on });
    if (on) { this.fetchEstimates(); }
  };

  toggleEstSingles = () => {
    this.setState({ includeEstSingles: !this.state.includeEstSingles });
  };

  loadIntervalDispatchState() {
    const { loadDispatch, centerId, ignoreDisconnect, location } = this.props;
    const query = new URLSearchParams(location.search);
    const sub = query.get("sub");
    if (loadingInterval !== null) {
      window.clearInterval(loadingInterval);
    }
    loadingInterval = window.setInterval(function() {
      if (document.visibilityState && document.visibilityState === 'hidden') {
        ignoreDisconnect();
        console.log('skipped load dispatch because not visible');
        return;
      }
      if(document.pause_dispatch_load){
        ignoreDisconnect();
        console.log('skipped load dispatch because pause_dispatch_load');
        return;
      }
      loadDispatch(centerId, sub);
    }, 20000);
  }


  componentDidMount() {
    const { loadDispatch, centerId, location } = this.props;
    const query = new URLSearchParams(location.search);
    const sub = query.get("sub");
    loadDispatch(centerId, sub);
    this.loadIntervalDispatchState();
  }

  componentDidUpdate(prevProps) {
    const { centerId } = this.props;
    if (prevProps.centerId !== centerId) {
      this.loadIntervalDispatchState();
    }
  }

  render() {
    const { loading, centers, centerId, loadDispatch, location } = this.props;
    const query = new URLSearchParams(location.search);
    const sub = query.get("sub");
    if (loading) {
      return <h1 style={{textAlign: "center", marginTop: "100px", opacity: "0.6"}}>Chargement...</h1>;
    }

    let center = findByid(centers, centerId);
    if (center.is_shadow_groupment_enabled === false) {
      return <h1 style={{textAlign: "center", marginTop: "100px", opacity: "0.6"}}>Le Shadow Groupement est désactivé pour ce centre</h1>;
    }

    /*
     * On défini les 2 colonnes : 
     * - A gauche la liste des commandes à dispatcher (Deliveries)
     * - A droite la liste des Docks (chariots) + livreurs + livraison en cours (Docks)
     */
    const { showTools, showDeliveries, highlightParis, includeEstSingles, showEstimates, dockEstimates, estimatesDiagnostic, estimatesLoading } = this.state;
    // Totaux estimés recalculés côté client (respecte le filtre « inclure les tournées à 1 commande »).
    const estEntries = Object.values(dockEstimates || {});
    const estShown = includeEstSingles ? estEntries : estEntries.filter((d) => (d.n_orders || 0) >= 2);
    const et = estShown.length ? estTotals(estShown) : null;
    const ep = estShown.length ? estTotals(estShown.filter((d) => d.is_paris)) : null;
    return (
      <DockEstimatesContext.Provider value={showEstimates ? dockEstimates : {}}>
      <DockHighlightContext.Provider value={highlightParis}>
      <div className="Dispatch">
        <div className={`row${showDeliveries ? "" : " deliveries-hidden"}`}>
          {showDeliveries && <Deliveries />}
          <Docks />
        </div>
        <ConfirmModal />
        <ChangeNumberOfBagsModal />
        <TransitAreaModal />
        <ChangeTrolleyLocationModal />
        <ReviewLateOrderModal />
        <ReturnBagsDepositModal />
        <RouteComparisonModal />
        <UberCallModalLinked />
        <StuartCallModalLinked />
        <UberDirectBatchModalLinked />
        <UberCancelResolutionModalLinked />
        <RedeliverOrRestockModal />
        <CommonModals />

        <button
          className={`DispatchTools-handle${showTools ? " open" : ""}`}
          onClick={this.toggleTools}
          title="Outils dry-run"
        >
          {showTools ? "✕ Outils" : "⚙ Outils"}
        </button>

        {showTools && (
        <div className="DispatchTools">
          <SourceSwitch onReload={() => { loadDispatch(centerId, sub); if (this.state.showEstimates) { this.fetchEstimates(); } }} />
          <button className="DispatchTools-btn" onClick={this.toggleDeliveries}>
            {showDeliveries ? "Masquer les commandes à dispatcher" : "Afficher les commandes à dispatcher"}
          </button>
          <label className="DispatchTools-check">
            <input type="checkbox" checked={highlightParis} onChange={this.toggleHighlightParis} />
            Entourer les tournées Paris intramuros
          </label>
          <div className="DispatchTools-est">
            <button className={`DispatchTools-btn${showEstimates ? " on" : ""}`} onClick={this.toggleEstimates}>
              {showEstimates ? "Masquer les coûts estimés" : "Afficher les coûts estimés (lib)"}
            </button>
            {showEstimates && (
              <button className="DispatchTools-refresh" onClick={this.fetchEstimates} disabled={estimatesLoading} title="Recalculer">
                {estimatesLoading ? "…" : "↻"}
              </button>
            )}
          </div>
          {showEstimates && (
            <label className="DispatchTools-check">
              <input type="checkbox" checked={includeEstSingles} onChange={this.toggleEstSingles} />
              inclure les tournées à 1 commande
            </label>
          )}
          {showEstimates && estimatesDiagnostic && (
            <div className="DispatchTools-diag">⚠ {estimatesDiagnostic}</div>
          )}
          {showEstimates && et && (
            <div className="DispatchTools-totals">
              <div>lib estim. : <b>{et.docks}</b> tournées · <b>{et.cost_eur}</b> € · retard <b>{et.delay_min}</b>m · avance <b>{et.wait_min}</b>m</div>
              {ep && (
                <div className="DispatchTools-totals-paris">
                  dont Paris intramuros : <b>{ep.docks}</b> tournées · <b>{ep.cost_eur}</b> € · retard <b>{ep.delay_min}</b>m · avance <b>{ep.wait_min}</b>m
                </div>
              )}
            </div>
          )}
          <a className="DispatchTools-btn DispatchTools-link" href="/dispatch-dryrun" target="_blank" rel="noopener noreferrer">
            Comparateur dry-run ↗
          </a>
          <a className="DispatchTools-btn DispatchTools-link" href="/dispatch-simulation" target="_blank" rel="noopener noreferrer">
            Simulations ↗
          </a>
        </div>
        )}
      </div>
      </DockHighlightContext.Provider>
      </DockEstimatesContext.Provider>
    );
  }
}

InternalDispatch.propTypes = {
  centerId: PropTypes.number,
  centers: PropTypes.array,
  loading: PropTypes.bool,
  loadDispatch: PropTypes.func,
  ignoreDisconnect: PropTypes.func,
};


export const Dispatch = withRouter(connect(
  (state) => {
    return {
      loading: state.dispatch.firstLoad,
      centers: state.dispatch.metas.centers,
      centerId: extractCenterId(state.user),
    };
  },
  (dispatch) => {
    return {
      ignoreDisconnect: () =>{
        dispatch(ignoreDisconnect())
      },
      loadDispatch: (centerId, sub) => {
        try {
          dispatch(loadDispatch(centerId, sub))
        } catch (e) {
          console.log("Error while trying to load dispatch", e)
          dispatch(loadDispatchError(centerId))
        }
      },
    };
  }
)(InternalDispatch));
